export default "__VITE_ASSET__FBGQ12T1__"